import RequestMockAdapter from '../../util/RequestMockAdapter';
import { isDevMode } from '../../util/RuntimeUtils';

export default class {
    constructor(apiRequest){
        if (isDevMode()) {
            const mockAdapter = new RequestMockAdapter(apiRequest, { delayResponse: 1000 });
            mockAdapter
                .onGet('/site/myresources/sso/profiles')
                .reply(200, [
                    {userName: 'ahughes131', providerTaxId: '12345'},
                    {userName: 'ahughes99', providerTaxId: '67890'},
                    {userName: 'ahughes131', providerTaxId: '12345'},
                    {userName: 'ahughes99', providerTaxId: '67890'},
                    {userName: 'ahughes131', providerTaxId: '12345'},
                    {userName: 'ahughes99', providerTaxId: '67890'},
                ]);

            mockAdapter
                .onPost('/auth/authentication/constituent')
                .reply(200, {
                    authenticationSuccessful: false,
                    newPasswordInvalid: true,
                    constituentType: 'prime'
                });
        }
    }
}
